export default __webpack_public_path__ + "static/media/d.8f8fe24e.jpg";